
import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';

import OutlinedInput from '@mui/material/OutlinedInput';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import SimCardRoundedIcon from '@mui/icons-material/SimCardRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import SearchIcon from '@mui/icons-material/Search';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import SendIcon from '@mui/icons-material/Send';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { styled } from '@mui/system';

import { DataGrid, GridRowsProp, GridColDef,GridRowId,GridToolbar,GridRowSelectionModel, GridRenderCellParams } from '@mui/x-data-grid';

import ImageMapper from 'react-img-mapper';
import type { MapArea, RefProperties } from 'react-img-mapper';

import { FunctionComponent, useEffect, useState } from 'react'
import useLocalStorageState ,{LocalStorageState} from 'use-local-storage-state'


// import {PrProduct,PrCartProps,PrCartBrandProps,PrBrandType,PrBrandsIf,prBrandsInfo,PrCartIf} from '../../components/Products'
import {PrProduct,PrCartProps,PrCartBrandProps,PrBrandType,PrBrandsIf,PrCartIf} from '../../components/Products'
import { PrCart } from '../../components/Cart';
import { Loader } from '../../components/Loader'

import {useAuth} from '../../context/AuthContext'
import {Ibu, Iuserinfo,iauthData} from '../../context/AuthContextTypes'
import {PrAvProvider, PrAvContext, usePrAvcontext} from '../../context/PrAVContext'

import {IPrAvResponseData,IPrAvResponse,IPrOrderResponseData,IPrOrderResponse} from '../PageInterfaces'

import KsrgrButton from './KsrgrButton'
import Paper from '@mui/material/Paper';

import {round} from '../../utils'
import { Tooltip } from '@mui/material';

import { returnBasenameUrl } from '../../utils';

interface IPrAvSearch {
  success: boolean,
  prcode: string,
  qty: number,
  data?: IPrAvResponseData
}

interface IPrBasketRow {
  id: number,
  code: string,
  code2: string,
  name: string,
  name1: string,
  uom: number,
  uomcode: string,
  uomname: string,
  pricer: number,
  pricew: number,
  brand: number,
  brandcode: string,
  brandname: string,
  mtrsup: number,
  info: string,
  origin: string,
  remqty: number,
  ordered: number,
  reserved: number,
  avqty: number,
  reqqty: number,
  lineval: number,
  discntperc: number,
  discntamnt: number,
  netlineval: number 
}

interface IPrBasketExpn {
  expndescription: string,
  expnnetval: number,  
}

interface IPrBasketSums {
  rows: number, 
  totqty: number, 
  totval: number,   
  totexpnval: number, 
  totamount:number,
  discntperc: number,
  discntamnt: number,
  totalnetval: number, 
  vatperc: number,
  totvatval: number,
  totsumval: number,
}


interface IPrModelRow {
  id: number,
  code: string,
  name: string,
}

const VATPERC=24.0


const FormGrid = styled(Grid)(() => ({
    display: 'flex',
    flexDirection: 'column',
}));


const ModelXYZParts:IPrModelRow[] = [
  {
    "id": 1,
    "code": "0110-895001-601KF2HK",
    "name":	"Left car body cover (glossy black + 3 red sticker)"
  },
  {
    "id": 2,
    "code": "0110-895001-601KG2HM",
    "name":	"Left  body cover (glossy black+sticker)"
  },
  {
    "id": 3,
    "code": "012554",
    "name":	"Ροδέλα"
  },
  {
    "id": 4,
    "code": "00N01000821",
    "name":	"Βάση"
  },
  {
    "id": 5,
    "code": "00H01600911",
    "name":	"Σινεμπλόκ 5,4x7,2x6"
  }
]


function getCartLength(cartobj:PrCartProps|undefined)
{
  return Object.values(cartobj || {}).reduce((accumulator, product) => accumulator + 1, 0)
}

type PrBrandSelProps = {
  prcart: PrCartProps | undefined
  fCb: Function
}



const PrBrandSel = (props:PrBrandSelProps) => {
  let pravcntxt = usePrAvcontext()
  let prBrandsInfo=pravcntxt.prContextData.prBrandsInfo as PrBrandsIf
  const [prbrandselected, setPrBrandselected] = React.useState(false);
  const [prbrand, setPrBrand] = useLocalStorageState(`${process.env.REACT_APP_PRCARTBRANDKEY}`, {defaultValue:''})
  //const [prcart, setPrCart] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})


  const handleBrandSelection = (event: SelectChangeEvent) => {
    if(getCartLength(props.prcart)>0){
      if (window.confirm("Αν αλλάξετε μάρκα, τα περιεχόμενα του καλαθιού θα διαγραφούν. Συνέχεια;") == true){
        setPrBrand(event.target.value as string);
        setPrBrandselected(true)
        // setCompstate('pravquestion')
        // setPrcode('');
        // setPrqty('');
        // setPrCart({})
        props.fCb(event.target.value as string)
      }
    }
    else {
      setPrBrand(event.target.value as string);
      setPrBrandselected(true)
      // setCompstate('pravquestion')  
      // setPrcode('');
      // setPrqty('');
      // setPrCart({})
      props.fCb(event.target.value as string)
    }
  }
  return (
    <Stack spacing={{ xs: 3, sm: 6 }} useFlexGap>
    <Box sx={{ minWidth: 120, borderRadius: '20px',
        border: '1px solid ',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)'}}>
    <FormControl fullWidth sx={{backgroundColor: 'background.paper'}}>
      <InputLabel id="simple-select-brand">Επιλογή Μάρκας</InputLabel>
      <Select
        labelId="simple-select-brand"
        id="demo-simple-select"
        value={prbrand}
        label="Επιλογή Μάρκας"
        onChange={handleBrandSelection}
      >
        {Object.entries(prBrandsInfo).map( value  => {
         return <MenuItem  key={value[0]} value={value[0]}>{value[1].marktitle}</MenuItem>} ) 
         }
      </Select>
    </FormControl>
    </Box>
    </Stack>
  )
}

type PrQueryProps = {
  prbrand: string,
  pcode: string,
  pqty:string
}
const PrQuery = ( props:PrQueryProps) => {
  let auth = useAuth();
  let pravcntxt = usePrAvcontext()
  let prBrandsInfo=pravcntxt.prContextData.prBrandsInfo as PrBrandsIf
  const [prsearch, setPrsearch] = React.useState<IPrAvSearch | null>(null);
  const [prcode, setPrcode] = React.useState(props.pcode);
  const [prqty, setPrqty] = React.useState(props.pqty);
  const [prcart, setPrCart] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})

  const [showtooltip, setShowtooltip ] = React.useState(false);
  const [tooltipxy, setTooltipxy ] = React.useState({x:0,y:0});
  const [tooltipname, setTooltipname ] = React.useState("");
  const tooltipRef = React.useRef<HTMLDivElement>(document.createElement('div'));

  const imgmapurl = "https://b2bksrgr.local/images/fiss/model001/E05.gif";
  const imgmapname = "e05";
  const imgareas = [
        {"shape":"circle","id":"530400-517B-00","title":"Main footrest assy","name":"12","coords":[66,23,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"12","name":"12","title":"12","coords":[111,43,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11-2-3","name":"11-2-3","title":"11-2-3","coords":[169,65,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11-2-2","name":"11-2-2","title":"11-2-2","coords":[206,92,20],"fillColor": "#ff000026","strokeColor": "red"},
        {"shape":"circle","id":"11","name":"11","title":"11","coords":[271,116,20],"fillColor": "#ff000026","strokeColor": "red"}
    ];

    const ref = React.useRef<RefProperties>(null);


  const handlePrcodeChange = (event: { target: { value: string } }) => {
    const value = event.target.value.replace(/\s/g, ''); // replace any whitespace char with empty char
    // if (value.length >= 3) {
      setPrcode(value);
    // }
  };
  const handlePrQtyNumberChange = (event: { target: { value: string } }) => {
    const value = event.target.value.replace(/\D/g, ''); // replace any non digit with empty char
    // const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
    if (value.length > 0) {
      setPrqty(value);
    }
  };
  function btnSearchClick(){
    // alert('btn clicked')
    if(auth.userData.success!==true) return
    if(prcode===undefined || prcode===null || prcode === "" || prcode.length<=0 ) return
    if(prqty===undefined || prqty===null || prqty === ""|| prqty.length<=0 ) return
    let token = auth.userData.token
    let usercode = auth.userData.username
    let postdata = {
      service: "getpravinfo", 
      usercode: usercode,
      prcode: prcode,
      prqty: prqty,
      prbrand: props.prbrand,
      markoption: prBrandsInfo[ parseInt(props.prbrand) ].markoption,      
      brandavfilter: prBrandsInfo[ parseInt(props.prbrand) ].brandavfilter,
      notbrandavfilter: prBrandsInfo[ parseInt(props.prbrand) ].notbrandavfilter,
      clientid: token
  }
  // let body = `{"service": "getPrAvInfo", "usercode": "${usercode}", "prcode": "${prcode}", "prqty": "${prqty}", "clientid": "${token}"}`
  let body = JSON.stringify(postdata)
  const ms = Date.now();
  let basename=returnBasenameUrl()
   let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
    body: body , cache: "no-store"
  })
  .then((response) =>  {
    if (!response.ok) return {} 
    else return response.json()
  })
  .then((data:any) => {
    // console.log(" PrAvOrd fetch Pr AV then ... data=",data)
    const isSuccessPrAvInfoResponse = (data: any): data is IPrAvResponse =>
    typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
    if (isSuccessPrAvInfoResponse(data) && data.success!==true)
    {
      // console.log(" PrAvOrd, fetched data NOT Success PrAvInfoResponse")
      let pravs: IPrAvSearch = {
        success: false,
        prcode: prcode,
        qty: parseFloat(prqty)
      }
      setPrsearch( pravs )
      alert('Η ερώτηση διαθεσιμότητας απέτυχε. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
    }
    else {
      // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
      if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){

        if( data.totalcount<=0) {
          let pravs: IPrAvSearch = {
            success: false,
            prcode: prcode,
            qty: parseFloat(prqty)
          }
          setPrsearch( pravs )
          // console.log(" fetched data totalcount<=0")
          alert('Η ερώτηση δεν επέστρεψε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
        }
        else {
          // const motosdata: IMotoBrand[] = data.rows
          let pravs: IPrAvSearch = {
            success: data.success,
            prcode: prcode,
            qty: parseFloat(prqty),
            data: data.data
          }
          setPrsearch( pravs )
          // console.log(" fetched data Success rows Array set")
        }
      }
      else {
        let pravs: IPrAvSearch = {
          success: false,
          prcode: prcode,
          qty: parseFloat(prqty)
        }
        setPrsearch( pravs )
        // console.log(" fetched  data NOT rows Array")
        alert('Η ερώτηση δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
      }
    }
  }) 
  }
  const addToCart = (product: PrProduct):void => {
    // product.quantity = 1

    setPrCart((prevCart) => {
      const updatedCart = { ...prevCart }
      const productId: string = product.id.toString()
      if (updatedCart[productId]) {
        updatedCart[productId] = { ...updatedCart[productId], 
          quantity: product.reqqty ,
          price: product.pricer,
          reqqty: product.reqqty ,
          lineval: product.lineval
        }
        return updatedCart
      }
      else {

          return {
            ...prevCart,
            [product.id]: product,
          }

      }

    })
  }
 function btnAddToCart(){
    if(prsearch?.data!==undefined) {
      let reqqty = parseFloat(prqty)
      let lineval = reqqty * prsearch?.data?.pricer
      let rows=0;
      let totqty=0
      let totval=0;
      let discprcnt=0;
      let discamnt=0;
      let totamount=0;
      let vatamnt=0;
      let expnamnt=0;

      let product: PrProduct = {
        id: prsearch?.data?.id,
        title: prsearch?.data?.name,
        price: prsearch?.data?.pricew,
        quantity: reqqty,
        code: prsearch?.data?.code,
        code2: prsearch?.data?.code2,
        name: prsearch?.data?.name,
        name1: prsearch?.data?.name1,
        uom: prsearch?.data?.uom,
        uomcode: prsearch?.data?.uomcode,
        uomname: prsearch?.data?.uomname,
        pricer: prsearch?.data?.pricer,
        pricew: prsearch?.data?.pricew,
        brand: prsearch?.data?.brand,
        brandcode: prsearch?.data?.brandcode,
        brandname: prsearch?.data?.brandname,
        mtrsup: prsearch?.data?.mtrsup,
        info: prsearch?.data?.info,
        origin: prsearch?.data?.origin,
        remqty: prsearch?.data?.remqty,
        ordered: prsearch?.data?.ordered,
        reserved: prsearch?.data?.reserved,
        avqty: prsearch?.data?.avqty,
        reqqty: reqqty,
        lineval: lineval,
        discntperc: 0,
        discntamnt: 0,
        netlineval: 0 ,
        thumbnail: '',
        image: ''     
      }
      addToCart(product);
    }
    setPrsearch(null);
    setPrcode('');
    setPrqty('');
  }
  return(
    <>
     <Stack spacing={{ xs: 3, sm: 6 }} useFlexGap>
    <Box id="box-compstate-pravdataentry"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, }} >
    <Box
      id="box-part1of-pravdataentry"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        height: { xs: 200, sm: 200, md: 200 },
        width: '100%',
        borderRadius: '20px',
        border: '1px solid ',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.05)',
      }}
    >

      <Box id="box-fieldsrow1-pravdataentry"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: 2,
        }}
      >                        
        {/* <FormGrid sx={{ flexGrow: 1 }}>
         <FormLabel>{prBrandsInfo[parseInt(props.prbrand)].marktitle}</FormLabel>
        </FormGrid> */}

        <FormGrid sx={{ flexGrow: 1 }}>
          <FormLabel htmlFor="partcode" required>Κωδικός Ανταλλακτικού</FormLabel>
          <OutlinedInput
            id="partcode"
            autoComplete="partcode"
            placeholder="Κωδικός Ανταλλακτικού"
            required
            value={prcode}
            onChange={handlePrcodeChange}
          />
        </FormGrid>
        <FormGrid sx={{ maxWidth: '30%' }}>
          <FormLabel htmlFor="partqty" required>Ποσότητα</FormLabel>
          <OutlinedInput
            id="partqty"
            autoComplete="partqty"
            placeholder="ποσότητα"
            required
            value={prqty}
            onChange={handlePrQtyNumberChange}
          />
        </FormGrid>

        <FormGrid sx={{ maxWidth: '20%' }}>
          <KsrgrButton text={'unused'} startIcon={<SearchIcon />} onClick={btnSearchClick}> <SearchIcon />{'ευρεση'} </KsrgrButton> 
        </FormGrid>

      
      </Box>

      <Box id="box-fieldsrow2-pravdataresult"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: 2,
          mt: 3
        }}
      >
        {prsearch?.success && (
        <> 
        <FormGrid sx={{ flexGrow: 1 }}>
          <FormLabel >{prsearch?.data?.code}{' '}{prsearch?.data?.name}</FormLabel>
        </FormGrid>
        <FormGrid sx={{ flexGrow: 1 }}>
          <FormLabel >{prsearch?.data?.info}</FormLabel>
        </FormGrid>
        <FormGrid sx={{ flexGrow: 1 }}>
          <FormLabel >{'Λ.Τ.: '}{prsearch?.data?.pricer.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } )}{' Χ.Τ.: '}{prsearch?.data?.pricew.toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 } )}</FormLabel>
        </FormGrid>      
        <FormGrid sx={{ flexGrow: 1 }}>
          <FormLabel >
          { prsearch?.data && prsearch?.data?.avqty<=0 && <Chip size="small" label="μη διαθέσιμο" color="error" />}
          { prsearch?.data && prsearch?.data?.avqty>0 && parseFloat(prqty)>prsearch?.data?.avqty && <Chip size="small" label="μερικώς διαθέσιμο" color="warning" />}
          { prsearch?.data && prsearch?.data?.avqty>0 && parseFloat(prqty)<=prsearch?.data?.avqty && <Chip size="small" label="διαθέσιμο" color="success" />}
          { !prsearch?.data && <Chip size="small" label="μη διαθέσιμο" color="error" />}              
          </FormLabel>
        </FormGrid>        
        <FormGrid sx={{ flexGrow: 1 }}>
          <Button size="small" variant="contained" onClick={(e)=>{btnAddToCart()}}> <AddShoppingCartIcon /> </Button>  

        </FormGrid>        
        </>
        )}
    </Box>


    </Box>

    </Box>
    </Stack>

    </>
  )
}

type PrModelAvProps ={
  prbrand:string
}
const PrModelAv = (props:PrModelAvProps) => {
  const [prcode, setPrcode] = React.useState('');
  const [prqty, setPrqty] = React.useState('');
  const [modelpropen, setModelpropen] = React.useState(false);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('md');
  const [fullWidth, setFullWidth] = React.useState(true);

  const prModelColumns : GridColDef[] = [  // , width: 150
    { field: 'code',
      type: 'string',
      headerName: 'Κωδικός',
      disableReorder: true,
      hideable: false,
      flex:1
    },
    {
      field: 'name',
      type: 'string',
      headerName: 'Περιγραφή',
      disableReorder: true,
      hideable: false,
      flex:2
    },
    {
      field: 'id',
      type: 'number',
      headerName: ' Επιλογή ',
      disableReorder: true,
      hideable: false,
      flex:1,
      renderCell: (params: GridRenderCellParams<any, number>) => (
        <strong>
            <IconButton color="primary" aria-label="delete row" tabIndex={params.hasFocus ? 0 : -1} onClick={(e)=>{handleBtnSelModelPrRow(e, params.row)}} >
              <RadioButtonUncheckedIcon />
            </IconButton>
          </strong>
        ),
    }
  ]
  type Order = 'asc' | 'desc';
  function getRowId(row:IPrModelRow) {
    return row.id;
  }
  function handleBtnSelModelPrRow(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, rowboj:any){
    if( (rowboj) && (rowboj.id) )
    {
      setPrcode(rowboj.code);
      setPrqty('1');
      setModelpropen(true)
    }
  }
  function closeModelPrModal(){
    // setPrsearch(null);
    setPrcode('');
    setPrqty('');
    setModelpropen(false)
  }
  return (
    <>
      <Dialog fullWidth={fullWidth} maxWidth={maxWidth} open={modelpropen} onClose={closeModelPrModal} >
      <DialogTitle>Ελεγχος Διαθεσιμότητας, Τιμές</DialogTitle>
      <DialogContent>
        <PrQuery prbrand={props.prbrand} pcode={prcode} pqty={prqty} /> 
      </DialogContent>
      <DialogActions>
          <Button autoFocus onClick={closeModelPrModal}>
            κλεισιμο
          </Button>
        </DialogActions>
      </Dialog>

    {/* <PrQuery prbrand={prbrand} pcode={''} pqty={''} /> */}
    <Paper sx={{ width: '100%', mb: 2 }}>
    <Box>
      <Typography  variant="h5" component="h5">ΑΝΤΑΛΛΑΚΤΙΚΑ MODELXYZ</Typography>
    </Box>
    <DataGrid rows={ModelXYZParts} columns={prModelColumns} getRowId={getRowId} density={'compact'}
      initialState={{
        pagination: { paginationModel: { pageSize: 25 } },
      }}
      pageSizeOptions={[25, 50]}
      disableColumnMenu        
      checkboxSelection={false}   
      disableMultipleRowSelection={true}
      onRowSelectionModelChange = {(rowSelectionModel, details) => {
      }}
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        columnsManagement: {
          toggleAllMode: 'filteredOnly',          
        },       
        filterPanel: {
          disableAddFilterButton: true,
          disableRemoveAllButton: true,
        },
        toolbar: {printOptions: { disableToolbarButton: true },csvOptions: { disableToolbarButton: true },}
      }} 
    />
    </Paper>
  </>

  )
}

function PrAvOrd() {

  const [prsearch, setPrsearch] = React.useState<IPrAvSearch | null>(null);
  const [prcode, setPrcode] = React.useState('');
  const [prqty, setPrqty] = React.useState('');
  const [prbrandselected, setPrBrandselected] = React.useState(false);
  const [prbrand, setPrBrand] = useLocalStorageState(`${process.env.REACT_APP_PRCARTBRANDKEY}`, {defaultValue:''})
  // const [prbrand, setPrBrand] = useLocalStorageState(`${process.env.REACT_APP_PRCARTBRANDKEY}`, {defaultValue:'9999'})
  // const [prbrandselected, setPrBrandselected] = React.useState(true);

  const [prcart, setPrCart] = useLocalStorageState<PrCartProps>(`${process.env.REACT_APP_PRCARTKEYNAME}`, {})
  const [lockprcart, setlockPrCart] = React.useState(false)

  /* type Order = 'asc' | 'desc'; */

  const isInCart = (productId: number):boolean => Object.keys(prcart || {}).includes(productId.toString())
  const getProducts = () => Object.values(prcart || {})
  const basketlines = getProducts().reduce((accumulator, product) => accumulator + 1, 0)
 
  const hBrandSelection = ( spbrand:string) => {
    setPrBrand(spbrand);
    setPrBrandselected(true)
    // setCompstate('pravquestion')  
    setPrcode('');
    setPrqty('');
    setPrCart({})
  }
  

  React.useEffect(()=>{
    // console.log('PrAvOrd :: useEffect[ getCartLength ]...' )
    if(getCartLength(prcart)>0) setlockPrCart(true)
    else setlockPrCart(false)
  },[getCartLength])


  return (
    <>
    <PrBrandSel prcart={prcart} fCb={hBrandSelection} />
    { ( prbrand!==undefined && prbrand!==null && prbrand !=='' && parseInt(prbrand) < 10000 ) && 
      <PrQuery prbrand={prbrand} pcode={''} pqty={''} />
    }
    { ( prbrand!==undefined && prbrand!==null && prbrand !=='' && parseInt(prbrand) > 10000 ) && 
     <PrModelAv prbrand={prbrand}/> }
    </>
  )
}
export default PrAvOrd


 